export default __webpack_public_path__ + "static/media/loadSpinner.61754d3f.svg";